// extracted by css-extract-rspack-plugin
export default {"root":"PhSc4H","flames":"FHn5fF","flame":"LXZoZ3"};